import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SubscriptionStatus } from '../enums';
import { SubscriptionStatusProviderService } from '../providers';

@Pipe({
  name: 'subscriptionStatus',
})
export class SubscriptionStatusPipe implements PipeTransform {
  private readonly provider = inject(SubscriptionStatusProviderService);

  public transform(status: SubscriptionStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
